import React from 'react';
import PropTypes from 'prop-types';

function InfoItalic({ size, stroke, ...otherProps }) {
  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 14.27344,16.976601 -0.17188,0.7031 c -0.51563,0.2031 -0.92708,0.3581 -1.23437,0.4648 -0.3073,0.1068 -0.66406,0.1602 -1.07032,0.1602 -0.625,0 -1.11067,-0.1524 -1.45703,-0.457 -0.346352,-0.3047 -0.519528,-0.6914 -0.519528,-1.1602 0,-0.1823 0.01302,-0.3685 0.03906,-0.5586 0.02604,-0.1901 0.06771,-0.40494 0.125,-0.64452 L 10.625,13.203121 c 0.05729,-0.21875 0.10547,-0.42578 0.14453,-0.62109 0.03906,-0.19531 0.05859,-0.3737 0.05859,-0.53515 0,-0.29167 -0.05989,-0.4948 -0.17968,-0.60938 -0.11979,-0.114581 -0.34896,-0.171881 -0.687503,-0.171881 -0.166667,0 -0.337238,0.02605 -0.5117175,0.07813 -0.17448,0.05208 -0.324218,0.101561 -0.449219,0.148441 l 0.171875,-0.70313 C 9.593752,10.61719 9.997394,10.47005 10.38281,10.34766 c 0.38542,-0.1224 0.75,-0.183599 1.09375,-0.183599 0.6198,0 1.09766,0.149739 1.4336,0.44922 0.33594,0.299479 0.5039,0.6888 0.5039,1.16797 0,0.09896 -0.01172,0.27344 -0.03515,0.52344 -0.02344,0.25 -0.06641,0.47916 -0.12891,0.6875 l -0.64063,2.27343 c -0.05208,0.1823 -0.09895,0.39063 -0.14062,0.625 -0.04167,0.23438 -0.0625,0.41148 -0.0625,0.53128 0,0.3021 0.06771,0.5078 0.20312,0.6172 0.13542,0.1093 0.3698,0.164 0.70313,0.164 0.15625,0 0.33333,-0.0273 0.53125,-0.082 0.19792,-0.0547 0.34115,-0.1029 0.42969,-0.1445 z M 14.4375,7.4375005 c 0,0.39584 -0.14974,0.733071 -0.44922,1.01172 -0.29948,0.278651 -0.66015,0.417971 -1.08203,0.417971 -0.42188,0 -0.78385,-0.13932 -1.08594,-0.417971 -0.30208,-0.278649 -0.45312,-0.615879 -0.45312,-1.01172 0,-0.39584 0.15104,-0.734373 0.45312,-1.015625 0.30209,-0.281251 0.66406,-0.421875 1.08594,-0.421875 0.42188,0 0.78255,0.140624 1.08203,0.421875 0.29948,0.281252 0.44922,0.619785 0.44922,1.015625 z"
        fill={stroke}
      />
    </svg>
  );
}

InfoItalic.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default InfoItalic;
